import React from 'react';
import _size from 'lodash/size';
import { ColumnDiv } from 'styles/elements/div';
import TextField, { CharacterCounter } from 'styles/blocks/textField';
import PreviewContainer from 'styles/blocks/photoUpload/preview';

export const Preview = ({ updatePhotoDescription, photo, onDeletePhoto, id, isInvalid, textareaRef }) => (
  <PreviewContainer>
    <PreviewContainer.PreviewImage src={photo.fileBytes} alt={`Uploaded photo ${id}`} />
    <ColumnDiv modifier={['flexFill']}>
      <PreviewContainer.RemoveButton onClick={() => onDeletePhoto(id, photo)}>X</PreviewContainer.RemoveButton>
      <PreviewContainer.Text>Briefly tell us what the photo is showing</PreviewContainer.Text>
      <TextField>
        <CharacterCounter answerLength={_size(photo.fileDescription)} maxLength={500} id={`max-char-label-${id}`} />
        <PreviewContainer.Textarea
          value={photo.fileDescription}
          onChange={event => updatePhotoDescription(id, event.target.value)}
          aria-label="Briefly tell us what the photo is showing"
          aria-describedby={`max-char-label-${id}`}
          isInvalid={isInvalid}
          ref={textareaRef}
        />
      </TextField>
    </ColumnDiv>
  </PreviewContainer>
);
